var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-tabbar",
        {
          model: {
            value: _vm.tabbarActive,
            callback: function($$v) {
              _vm.tabbarActive = $$v
            },
            expression: "tabbarActive"
          }
        },
        [
          _c(
            "van-tabbar-item",
            { attrs: { icon: "comment-o", replace: "", to: "/ticket-vue/my" } },
            [_vm._v("工单")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            {
              attrs: {
                icon: "apps-o",
                replace: "",
                to: "/ticket-vue/view-list"
              }
            },
            [_vm._v("视图")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            { attrs: { icon: "add-o", replace: "", to: "/ticket-vue/n2" } },
            [_vm._v("新增")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            {
              attrs: { icon: "volume-o", replace: "", to: "/ticket-vue/event" }
            },
            [_vm._v("动态")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            { attrs: { icon: "user-o", replace: "", to: "/ticket-vue/me" } },
            [_vm._v("我")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40bdfe18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40bdfe18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketTabbar.vue
// module id = 628
// module chunks = 75